import {Component} from '@angular/core';
import {BaseComponent} from '../base.component';

/**
 * Component.
 */
@Component({
    selector: 'contact',
    template: `
        <div style="padding-bottom: 10px; text-align: center">
            <img height="100" alt="Logo" src="assets/images/logo_icon.svg" />
            <i18n-selector></i18n-selector>
        </div>
		<div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); padding: 5px 10px 5px 10px">
            <h1>{{v('contact')}}</h1>
            <p>
                <strong>Kundencenter</strong><br />
				Telefon: {{'TENANT_SVC_PHONE' | env}}<br />

                E-Mail: {{'TENANT_SVC_EMAIL' | env}}<br />
			</p>
            <!-- <div class="EmptyBox30"></div> -->
            <p>
                <strong>Postanschrift</strong><br />
				{{'TENANT_NAME' | env}}<br />
                Kundencenter<br />
                Alte Rhinstraße 4<br />
                12681 Berlin<br />
			</p>
        </div>
        <div style="padding-top: 15px; text-align: center;">
            <span><strong>&#169; 2014–{{year}} food safety qualITy GmbH</strong><br /></span>
            <span><strong>Alle Rechte vorbehalten.</strong></span>
        </div>
		`
})
export class ContactComponent extends BaseComponent {
    year = new Date().getFullYear()
}

